import React, { useContext } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { UiButton } from '@shared/ui/UiButton';

import cls from './ImageCard.module.css';
import { measurementsActions } from '../../../../store/slices/measurementsSlice/measurementsSlice';
import { MeasuremntsContext } from '../../Context/MeasuremntsContext';
import { findCurrentImage } from '../../helpers/findCurrentImage';

export const ImageCard = ({ src, index }) => {
    const dispatch = useDispatch();
    const {
        setImageList,
        setCurrentUrl,
        setCurrentIndex,
        imageList,
        setImagesDelete,
        showPopup,
        hidePopup,
    } = useContext(MeasuremntsContext);

    const { isEdited } = useSelector((state) => state.measurementsReducer);

    const onClickDeleteButton = (event) => {
        event.stopPropagation();
        showPopup({
            needCrossIcon: false,
            text: (
                <>
                    {i18next.t('ImageCard.return.onClickDeleteButton.text.part1')}
                    <br />
                    {i18next.t('ImageCard.return.onClickDeleteButton.text.part2')}
                </>
            ),
            danger: i18next.t('ImageCard.return.onClickDeleteButton.danger'),
            cancel: i18next.t('ImageCard.return.onClickDeleteButton.cancel'),
            onSubmit: () => {
                hidePopup();
                if (!isEdited) dispatch(measurementsActions.changeIsEdited(true));
                const currentImage = imageList.find((image) => image.previewUrl === src);
                if (currentImage && currentImage.id) {
                    setImagesDelete((prev) => [...prev, currentImage.id]);
                }
                setImageList((prev) => prev.filter((preview) => preview.previewUrl !== src));
            },
            onCancel: () => hidePopup(),
        });
    };
    const onClickImage = () => {
        dispatch(measurementsActions.changeIsOpenPrevImage(true));
        setCurrentUrl(findCurrentImage(src, imageList));
        setCurrentIndex(index);
    };
    return (
        <div className={cls.Card} onClick={onClickImage}>
            <img src={src} alt="" draggable={false} />
            <div className={cls.DeleteCard}>
                <UiButton
                    onClick={onClickDeleteButton}
                    className={cls.buttonDelete}
                    variant="icon"
                    startIcon={
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.57598 4.57607C4.77132 4.38078 5.03623 4.27108 5.31244 4.27108C5.58865 4.27108 5.85356 4.38078 6.0489 4.57607L9.99994 8.52711L13.951 4.57607C14.0471 4.47658 14.162 4.39722 14.2891 4.34263C14.4162 4.28803 14.5529 4.2593 14.6912 4.2581C14.8295 4.25689 14.9667 4.28325 15.0947 4.33563C15.2227 4.388 15.339 4.46535 15.4368 4.56315C15.5346 4.66096 15.612 4.77726 15.6643 4.90528C15.7167 5.0333 15.7431 5.17046 15.7419 5.30877C15.7407 5.44709 15.7119 5.58377 15.6573 5.71086C15.6027 5.83795 15.5234 5.95289 15.4239 6.04898L11.4729 10L15.4239 13.9511C15.6136 14.1475 15.7186 14.4107 15.7163 14.6838C15.7139 14.9569 15.6043 15.2182 15.4112 15.4113C15.2181 15.6044 14.9568 15.714 14.6837 15.7164C14.4106 15.7187 14.1474 15.6137 13.951 15.424L9.99994 11.4729L6.0489 15.424C5.85244 15.6137 5.58931 15.7187 5.31619 15.7164C5.04307 15.714 4.7818 15.6044 4.58867 15.4113C4.39554 15.2182 4.28599 14.9569 4.28361 14.6838C4.28124 14.4107 4.38623 14.1475 4.57598 13.9511L8.52702 10L4.57598 6.04898C4.3807 5.85364 4.271 5.58874 4.271 5.31252C4.271 5.03631 4.3807 4.77141 4.57598 4.57607Z"
                                fill="#252733"
                            />
                        </svg>
                    }
                />
            </div>
        </div>
    );
};
